import { useMemo } from 'react';
import useFetchTransactions from './useFetchTransactions';

const useBarChartData = ({ company }) => {
  const { data, loading, error } = useFetchTransactions(
    { company },
    'barChart'
  );

  const barChartData = useMemo(() => {
    if (loading || error) return {};

    const groupedData = {};

    data.forEach((transaction) => {
      const { datePayed, amount, paymentMethod } = transaction;

      const [day, month, year] = datePayed.split(' ')[0].split('/').map(Number);
      if (!year || isNaN(year) || !month || isNaN(month)) return;

      if (!groupedData[year]) {
        groupedData[year] = {
          labels: Array(12)
            .fill(0)
            .map((_, index) =>
              new Date(0, index).toLocaleString('es-CO', { month: 'long' })
            ),
          datasets: {
            payments: Array(12).fill(0),
            totalRecaudado: Array(12).fill(0),
            transacciones: Array(12).fill(0),
          },
          paymentMethods: {},
        };
      }

      const monthIndex = month - 1;
      const parsedAmount =
        parseFloat(amount.replace(/\./g, '').replace(',', '.')) || 0;

      groupedData[year].datasets.payments[monthIndex] += 1;
      groupedData[year].datasets.totalRecaudado[monthIndex] += parsedAmount;
      groupedData[year].datasets.transacciones[monthIndex] += 1;

      if (!groupedData[year].paymentMethods[paymentMethod]) {
        groupedData[year].paymentMethods[paymentMethod] = 0;
      }
      groupedData[year].paymentMethods[paymentMethod] += parsedAmount;
    });

    const formattedData = Object.entries(groupedData).reduce(
      (acc, [year, value]) => {
        acc[year] = {
          labels: value.labels.slice(0, 12),
          datasets: [
            {
              label: 'Pagos',
              data: value.datasets.payments.slice(0, 6),
              backgroundColor: '#43aca1',
              borderColor: '#149789',
              borderWidth: 1,
            },
            {
              label: 'Total Recaudado',
              data: value.datasets.totalRecaudado.slice(0, 6),
              backgroundColor: '#a9519c',
              borderColor: '#932683',
              borderWidth: 1,
            },
            {
              label: 'Transacciones',
              data: value.datasets.transacciones.slice(0, 6),
              backgroundColor: '#f5aa51',
              borderColor: '#f29526',
              borderWidth: 1,
            },
          ],
          paymentMethods: value.paymentMethods,
        };
        return acc;
      },
      {}
    );

    return formattedData;
  }, [data, loading, error]);

  return { barChartData, loading, error };
};

export default useBarChartData;
